import dynamic from 'next/dynamic';

import { DataTableSkeleton } from '@kc-console/common-ui';
import { ListLayout, ListSection } from '@kc-console/layout';
import { PageHeader } from '@kc-console/shared-ui';

import ServiceStatusBanner from './ServiceStatusBanner';

import { getRouterConfig } from '@/shared/config/routes';
import useBreadcrumbItemsWithRegion from '@/shared/hooks/useBreadcrumbItemsWithRegion';
import { RssFeedButton } from '@/shared/ui';

const ServicesContent = dynamic(() => import('./ServicesContent'), {
  ssr: false,
  loading: () => <DataTableSkeleton showSideMargin />,
});

/**
 * Status Board 서비스 상태 페이지 템플릿.
 * @description
 * - 목록 레이아웃에 Breadcrumb, 타이틀, RSS 버튼을 포함한 PageHeader와 상태 테이블을 구성한다.
 * @example
 * <ServicesTemplate />
 */
const ServicesTemplate = () => {
  const breadcrumbs = useBreadcrumbItemsWithRegion(getRouterConfig());
  return (
    <ListLayout>
      <ListSection
        headerView={
          <>
            <PageHeader
              breadcrumbs={breadcrumbs}
              title="서비스 상태"
              mainActions={<RssFeedButton />}
            />
            <ServiceStatusBanner />
          </>
        }
      >
        <ServicesContent />
      </ListSection>
    </ListLayout>
  );
};

export default ServicesTemplate;
